import Link from 'next/link'
import css from '@styled-system/css'
import styled from 'styled-components'
import Stack from '@careguide/stack'
import { Body } from '@careguide/typography'

import { getSettingsMenuTabs, SettingsMenuEnum } from 'components/Settings/constants'

type SettingsMenuProps = {
  hideSubscriptionTab: boolean
  emailDigest: string
}

const SettingsMenu = ({ hideSubscriptionTab, emailDigest = '' }: SettingsMenuProps) => {
  const MenuTabs = hideSubscriptionTab
    ? getSettingsMenuTabs(emailDigest).filter((tab) => tab.id !== SettingsMenuEnum.PAYMENTS)
    : getSettingsMenuTabs(emailDigest)

  return (
    <SettingsList>
      {MenuTabs.map((tab, index) => {
        return (
          <Link key={index} href={tab.href} passHref={true}>
            <SettingTab aria-label={tab.label}>
              <img role='presentation' src={tab.icon} width='24px' />
              <SettingsLabel>
                <Body>{tab.label}</Body>
                <Body color='gray.5'>{tab.description}</Body>
              </SettingsLabel>
            </SettingTab>
          </Link>
        )
      })}
    </SettingsList>
  )
}

const SettingsList = styled.nav`
  > *:last-child {
    border-bottom: 0;
  }
`

const SettingTab = styled(Stack).attrs({
  gap: '4',
  direction: 'horizontal',
  valign: { _: 'top', desktop: 'center' },
})`
  ${css({
    cursor: 'pointer',
    borderBottom: ['1px solid', undefined, 'none'],
    borderRadius: ['none', undefined, 'small'],
    borderBottomColor: 'gray.2',
    p: '4',
    width: { _: '100%', desktop: '242px' },
    ':hover': {
      bg: ['gray.0', undefined, 'gray.1'],
    },
  })}
`

const SettingsLabel = styled.a`
  ${css({
    textDecoration: 'none',
    color: 'gray.6',
    '> *:first-child': {
      fontSize: [2, undefined, 1],
      fontWeight: ['bold', undefined, 'regular'],
    },
    '> *:last-child': {
      mt: [1, undefined, '0'],
      display: ['block', undefined, 'none'],
    },
  })}
`

export default SettingsMenu
